// extracted by mini-css-extract-plugin
export default {"cls1":"GX7KX4n0RwvVJZ5h91A3","cls2":"zYqKjHrMLE6GMWbsnjgd GX7KX4n0RwvVJZ5h91A3"};